import React from 'react';
import Icon from '../../../components/AppIcon';

const StepIndicator = ({ steps, currentStep }) => {
  return (
    <div className="flex items-center justify-between mb-8">
      {steps?.map((step, index) => (
        <React.Fragment key={step?.id}>
          <div className="flex flex-col items-center flex-1">
            <div
              className={`w-12 h-12 rounded-full flex items-center justify-center transition-all duration-300 ${
                index < currentStep
                  ? 'bg-success text-white'
                  : index === currentStep
                  ? 'bg-primary text-white shadow-lg'
                  : 'bg-muted text-muted-foreground'
              }`}
            >
              {index < currentStep ? (
                <Icon name="Check" size={20} />
              ) : (
                <Icon name={step?.icon} size={20} />
              )}
            </div>
            <div className="mt-3 text-center">
              <p
                className={`text-sm font-medium ${
                  index <= currentStep ? 'text-foreground' : 'text-muted-foreground'
                }`}
              >
                {step?.title}
              </p>
              <p className="text-xs text-muted-foreground mt-1 hidden sm:block">
                {step?.description}
              </p>
            </div>
          </div>
          {index < steps?.length - 1 && (
            <div
              className={`h-0.5 flex-1 mx-4 transition-all duration-300 ${
                index < currentStep ? 'bg-success' : 'bg-border'
              }`}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default StepIndicator;